<template>
  <PageLoading :loading="loading">
    <!-- 错误页面 -->
    <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

    <!-- 正常页面 -->
    <div v-else class="user-center">
      <!-- 用户信息卡片 -->
      <div class="user-card">
        <van-image class="avatar" round fit="cover"
          :src="Object.keys(user.face_image_arr || {}).length > 0 ? user.face_image_arr.face_image_url : userDefaultImage" />
        <div class="user-info">
          <div class="name-row">
            <span class="name">{{ user.name }}</span>
            <span class="id">ID: {{ user.wx_user_code }}</span>
            <van-tag class="face-tag" color="#DCFCE7" text-color="#16A34A" round
              v-if="Object.keys(user.face_image_arr || {}).length > 0">已录脸</van-tag>
            <van-tag color="#FEF9C3" text-color="#CA8A04" round class="face-tag" v-else>未录脸</van-tag>
            <!-- <div class="face-action" v-if="Object.keys(user.face_image_arr || {}).length == 0"
              @click="goToFaceRecognition">
              <van-icon name="photograph" class="face-icon" color="#8B0000" />
              <span class="face-text">去录入</span>
            </div> -->
          </div>
          <div class="role-tag-wrap">
            <div class="role-tag" v-if="user.is_parent">家长</div>
            <div class="role-tag" v-if="user.is_teacher">老师</div>
            <div class="role-tag" v-if="user.is_agent">业务员</div>
            <div class="role-tag" v-if="user.is_student">学生</div>
            <div class="role-tag" v-if="user.is_principal">校长</div>
            <div class="role-tag" v-if="user.is_customer">社区客户</div>
          </div>
          <!-- <van-button class="logout-btn" plain size="small" round type="primary" @click="logout">退出登录</van-button> -->
        </div>
      </div>

      <!-- 完善本人资料卡片 -->
      <div class="profile-completion-card-wrap">
        <div class="profile-completion-card" @click="goToProfileCompletion">
          <div class="profile-icon">
            <van-icon :name="require('@/assets/icons/finish_person.svg')" color="#8B0000" class="profile-icon-img" />
          </div>
          <div class="profile-content">
            <div class="profile-title">完善本人资料</div>
            <div class="profile-desc">修改个人信息，人脸信息和限购设置</div>
          </div>
          <div class="profile-arrow">
            <van-icon name="arrow" color="#9CA3AF" />
          </div>
        </div>
      </div>

      <!-- 用户统计数据 -->
      <div class="user-stats">
        <div class="stat balance-stat" @click="goToBalance">
          <div class="stat-header">
            <span class="stat-label">余额</span>
            <div class="recharge-btn" @click.stop="goToRecharge">
              <van-icon name="add" color="#8B0000" class="recharge-icon" />
              <span>去充值</span>
            </div>
          </div>
          <div class="stat-value money">¥{{ user.stored_account }}</div>
        </div>
        <div class="stat points-stat" @click="goToPoints">
          <div class="stat-header">
            <span class="stat-label">积分</span>
          </div>
          <div class="stat-value">{{ user.points_account }}</div>
        </div>
        <div class="stat" @click="goToCards">
          <div class="stat-header">
            <span class="stat-label">卡片</span>
          </div>
          <div class="stat-value">{{ user.card_count }}张</div>
        </div>
      </div>

      <!-- 功能区域 -->
      <div class="section-title">功能</div>
      <div class="grid">
        <template v-for="item in features">
          <div class="grid-item" v-if="item.show" :key="item.text" @click="goToFeature(item.text)">
            <div class="icon-wrap">
              <van-icon :name="item.icon" color="#8B0000" class="icon-img" />
            </div>
            <div class="grid-label">{{ item.text }}</div>
          </div>
        </template>
      </div>

      <!-- 联系客服弹框 -->
      <ContactService v-model:show="showCustomerService" :phone="customerServicePhone"
        :service-time="customerServiceTime" />
    </div>
  </PageLoading>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { setWxTitle } from '@/utils/wx'
import ContactService from '@/components/ContactService.vue'
import { post } from '@/utils/request'
import { WECHAT_APPID } from '../../../config/env'
import PageLoading from '@/components/PageLoading.vue'
import ErrorPage from '@/components/ErrorPage.vue'

// 加载状态
const loading = ref(true)
// 用户默认头像
const userDefaultImage = ref('')

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

const user = ref({})

const features = ref([
  { icon: require('@/assets/icons/order.svg'), text: '我的订单', show: true },
  { icon: require('@/assets/icons/agent.svg'), text: '联系客服', show: true },
  { icon: require('@/assets/icons/face.svg'), text: '录脸/限购', show: true },
  { icon: require('@/assets/icons/notice.svg'), text: '订奶须知', show: true },
  { icon: require('@/assets/icons/grant.svg'), text: '今日发放', show: false },
  { icon: require('@/assets/icons/class.svg'), text: '教师专区', show: false },
  // { icon: require('@/assets/icons/share.svg'), text: '转发订奶' },
  // { icon: require('@/assets/icons/share_face.svg'), text: '转发录脸' },
  { icon: require('@/assets/icons/address.svg'), text: '班级绑定', show: false },
  { icon: require('@/assets/icons/search.svg'), text: '查询修改', show: false },
  { icon: require('@/assets/icons/statistics.svg'), text: '订单统计', show: false },
  { icon: require('@/assets/icons/performance.svg'), text: '网点业绩', show: false },
  { icon: require('@/assets/icons/face_collection.svg'), text: '人脸采集', show: false },
  { icon: require('@/assets/icons/buy.svg'), text: '刷脸购买', show: true },
  { icon: require('@/assets/icons/report.svg'), text: '检测报告', show: true },
])

// 客服相关配置
const customerServicePhone = ref('')
const customerServiceTime = ref('')

// 处理错误
const handleError = (title, message) => {
  hasError.value = true
  errorTitle.value = title
  errorMessage.value = message
  loading.value = false
}

// 更新功能项的显示状态
const updateFeaturesVisibility = () => {
  features.value.forEach(feature => {
    if (feature.text === '今日发放') {
      feature.show = user.value.is_teacher
    } else if (feature.text === '教师专区') {
      feature.show = user.value.is_teacher
    } else if (feature.text === '班级绑定') {
      feature.show = user.value.is_agent
    } else if (feature.text === '查询修改') {
      feature.show = user.value.is_agent
    } else if (feature.text === '订单统计') {
      feature.show = user.value.is_principal
    } else if (feature.text === '网点业绩') {
      feature.show = user.value.is_agent
    } else if (feature.text === '人脸采集') {
      feature.show = user.value.is_agent || user.value.is_collect
    }
  })
}

onMounted(() => {
  setWxTitle('个人中心')
  initPage()
})

// 初始化微信授权
const initWechatAuth = () => {
  // 获取当前url中的code参数
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')

  // 判断用户取消授权
  const error = urlParams.get('error')
  const errorDesc = urlParams.get('error_description')
  if (error) {
    console.log('用户取消授权:', errorDesc)
    handleError('获取用户信息失败', errorDesc)
    return
  }

  if (!code) {
    // 如果没有code，重定向到微信授权页面
    const redirectUri = encodeURIComponent(window.location.href)
    const appId = WECHAT_APPID
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  } else {
    // 有code则获取用户信息
    getUserInfo({
      code: code,
      app_id: WECHAT_APPID,
      page_type: '首页'
    })
  }
}

// 获取用户信息
const getUserInfo = async (data) => {
  try {
    const res = await post('/api/index/info', data)

    if (res.result && res.result.state === 'ok') {
      const userInfo = res.result.partner_info || {}
      const accountInfo = res.result.account_info || {}
      // 存储用户ID到本地存储
      if (userInfo.id) {
        localStorage.setItem('userId', userInfo.id)
      }
      if (accountInfo.company_ids) {
        localStorage.setItem('company_ids', JSON.stringify(accountInfo.company_ids))
      }
      if (accountInfo.user_default_image) {
        localStorage.setItem('user_default_image', accountInfo.user_default_image)
      }
      initPage()
    } else {
      handleError('获取用户信息失败', res.result?.message || '获取用户信息失败')
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    handleError('获取用户信息失败', '获取用户信息失败，请重试')
  } finally {
    loading.value = false
  }
}

// 页面初始化
const initPage = async () => {
  try {
    // 检查是否已有用户ID
    if (localStorage.getItem('userId')) {
      // 这里可以调用接口获取用户信息数据
      const res = await post('/api/index/info', {
        page_type: '个人中心',
        app_id: WECHAT_APPID,
        partner_id: parseInt(localStorage.getItem('userId')),
      })
      if (res.result && res.result.state === 'ok') {
        user.value = res.result.partner_info
        // 更新功能项的显示状态
        updateFeaturesVisibility()
        // 获取客服配置信息
        if (res.result.account_info) {
          customerServicePhone.value = res.result.account_info.customer_service_phone
          customerServiceTime.value = res.result.account_info.service_time
          if (res.result.account_info.user_default_image) {
            localStorage.setItem('user_default_image', res.result.account_info.user_default_image)
            userDefaultImage.value = res.result.account_info.user_default_image
          }
        }
      } else {
        handleError('加载失败', res.result?.message || '接口异常')
      }
      loading.value = false
    } else {
      initWechatAuth()
    }
  } catch (error) {
    console.error('页面初始化失败:', error)
    handleError('加载失败', '页面加载失败，请重试')
    loading.value = false
  }
}

// 跳转到余额页面
const goToBalance = () => {
  window.location.href = '/balance'
}

const goToRecharge = () => {
  window.location.href = '/recharge'
}

const goToPoints = () => {
  window.location.href = '/points'
}

const goToCards = () => {
  window.location.href = '/cards'
}

// 联系客服弹框显示状态
const showCustomerService = ref(false)

const goToFeature = (text) => {
  console.log(text)
  if (text === '我的订单') {
    window.location.href = '/my-orders'
  } else if (text === '联系客服') {
    showCustomerService.value = true
  } else if (text === '刷脸购买') {
    window.location.href = '/face-purchase'
  } else if (text === '人脸采集') {
    window.location.href = '/face-collection'
  } else if (text === '检测报告') {
    window.location.href = '/inspection-report'
  } else if (text === '今日发放') {
    window.location.href = '/distribution-list'
  } else if (text === '教师专区') {
    window.location.href = '/class-summary'
  } else if (text === '班级绑定') {
    window.location.href = '/network-binding'
  } else if (text === '查询修改') {
    window.location.href = '/user-query'
  } else if (text === '订单统计') {
    window.location.href = '/order-statistics'
  } else if (text === '网点业绩') {
    window.location.href = '/network-performance'
  } else if (text === '订奶须知') {
    window.location.href = '/milk-notice'
  } else if (text === '录脸/限购') {
    window.location.href = '/students'
  }
}

const goToFaceRecognition = () => {
  window.location.href = '/face-recognition'
}

// 跳转到完善本人资料页面
const goToProfileCompletion = () => {
  window.location.href = '/profile-completion'
}

const logout = () => {
  localStorage.removeItem('userId')
  localStorage.removeItem('company_ids')
  localStorage.removeItem('user_default_image')
}

</script>

<style scoped>
.user-center {
  padding-bottom: calc(env(safe-area-inset-bottom) + 64px);
}

.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 21px;
}

.avatar {
  width: 52px;
  height: 52px;
  margin-right: 16px;
}

.user-info {
  flex: 1;
}

.name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.name {
  font-size: 16px;
  font-weight: 500;
  color: #222;
}

.id {
  color: #6B7280;
  font-size: 12px;
}

.face-tag {
  font-size: 10px;
  padding: 2px 7px;
}

.face-action {
  display: flex;
  align-items: center;
  gap: 4px;
}

.face-icon {
  font-size: 13px;
}

.face-text {
  color: var(--van-primary-color);
  font-size: 10px;
}

.role-tag-wrap {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.role-tag {
  display: inline-block;
  background: var(--van-primary-color);
  color: #fff;
  font-size: 12px;
  border-radius: 9999px;
  padding: 4px 11px;
}

.profile-completion-card-wrap {
  padding: 0 21px 10px 21px;
  background: #fff;
}

.profile-completion-card {
  display: flex;
  align-items: center;
  border: 1px solid rgba(254, 242, 242, 1);
  background: #fff;
  padding: 8px 14px;
  border-radius: 10px;
}

.profile-icon {
  margin-right: 12px;
}

.profile-icon-img {
  font-size: 24px;
}

.profile-content {
  flex: 1;
}

.profile-title {
  font-size: 12px;
  color: #000000;
  margin-bottom: 4px;
}

.profile-desc {
  font-size: 12px;
  color: #B3AFAF;
}

.profile-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.user-stats {
  display: flex;
  background: #fff;
  padding: 0 21px 21px 21px;
  border-bottom: 1px solid #f0f0f0;
  gap: 14px;
}

.stat {
  flex: 1;
  border-radius: 10px;
  background: #FEF2F2;
  padding: 14px;
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.stat-label {
  color: #6B7280;
  font-size: 12px;
}

.recharge-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: var(--van-primary-color);
  font-size: 10px;
}

.recharge-icon {
  margin-top: 2px;
  font-size: 12px;
}

.stat-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--van-primary-color);
}

.section-title {
  margin-top: 14px;
  background: #fff;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.grid {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  padding: 0 16px;
}

.grid-item {
  width: 25%;
  text-align: center;
  margin-bottom: 14px;
}

.icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  margin: 0 auto 7px auto;
  background: #f8f8f8;
  border-radius: 7px;
}

.icon-img {
  font-size: 20px;
}

.grid-label {
  font-size: 12px;
  color: #4B5563;
}

.logout-btn {
  margin-top: 8px;
  font-size: 12px;
  height: 24px;
}
</style>